// extracted by css-extract-rspack-plugin
export default {"cls1":"CoScientistLandingPage-cls1_3kt","cls2":"CoScientistLandingPage-cls2_7zs CoScientistLandingPage-cls1_3kt"};